import { Modal, ModalBody, ModalDialog, ModalHeader, ModalTitle } from '@ax/ui';
import { useEffect } from 'react';
import DOMPurify from 'dompurify';
import styles from './InfoModal.module.scss';
import useAnalytics from '@/hooks/useAnalytics.tsx';

export interface InfoModalProps {
  modalOpen?: boolean;
  modalClose?: () => void;
  content?: { title: string; content: { title: string; value: string }[] };
  analyticsProperties?: { preferenceType: string; noteSection: string };
}

const InfoModal = ({
  modalOpen = false,
  modalClose,
  content,
  analyticsProperties,
}: InfoModalProps) => {
  const analytics = useAnalytics();

  useEffect(() => {
    if (modalOpen) {
      analytics.onInfoModalOpened({ ...analyticsProperties });
    }
  }, [modalOpen]);

  const handleModalClose = () => {
    modalClose?.();
    analytics.onInfoModalClosed({ ...analyticsProperties });
  };

  return (
    <Modal
      className={styles.info_modal}
      onShow={modalOpen}
    >
      <ModalDialog classNames={styles.modal__width}>
        <ModalHeader onHide={handleModalClose}>
          <ModalTitle classNames={styles.info__main__title}>{content?.title}</ModalTitle>
        </ModalHeader>
        <ModalBody>
          {content?.content?.map((item, index) => {
            return (
              <div
                key={index}
                className={styles.content__container}
              >
                {item?.title && <div className={styles.content__title}>{item?.title}</div>}
                {item?.value && (
                  <div
                    className={styles.content__value}
                    dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(item?.value) }}
                  ></div>
                )}
              </div>
            );
          })}
        </ModalBody>
      </ModalDialog>
    </Modal>
  );
};

export default InfoModal;
